export default "__VITE_ASSET__bac7ad31__"